import _ from 'lodash-es';
import Query from '~/scripts/services/model/query';
import APIV5 from '~/models/api';
import Utils from '~/scripts/services/utils';
import MailFormHeaderController from '../mail-form-header/mail-form-header.controller';
import queryRecipientsSuggestion from './recipients-suggestion.query.json';
import queryRecipientsAutocomplete from './recipients-autocomplete.query.json';

export default class MailFormInputController {
	/* @ngInject */
	/**
	 * @param {import('angular').IRootElementService} $element
	 */
	constructor($element) {
		this.$element = $element;

		/** @type {any[]} */
		this.data = [];

		/** @type {?MailFormHeaderController} */
		this.form = null;

		/** @type {boolean} */
		this.loading = false;

		/** @type {any} */
		this.model = null;

		/** @type {?import('angular').INgModelController} */
		this.ngModelCtrl = null;

		/** @type {?Function} */
		this.onSelect = null;

		/** @type {any} */
		this.options = {
			ml: false,
		};

		/** @type {any[]} */
		this.recipients = [];

		/** @type {boolean} */
		this.required = false;

		/** @type {'from' | 'to' | 'cc' | 'bcc' | undefined} */
		this.type = undefined;
	}

	/**
	 * @param {'from' | 'to' | 'cc' | 'bcc'} type
	 * @param {any} r
	 */
	addRecipient(type, r) {
		const recipient = _.merge({ type }, r);
		if (this.onSelect) {
			this.onSelect({ $recipient: recipient });
		}
		this.data.push({
			type,
			recipient,
		});
		if (this.form) {
			this.form.setFocus(type);
		}
		this.model = undefined;
		this.ngModelCtrl?.$validate();
	}

	addEmail() {
		if (Utils.checkEmail(this.model) && this.type) {
			this.addRecipient(this.type, { email: this.model });
			this.$element.find(`.form-control[name=recipient_${this.type}]`).trigger('blur');
		}
		else {
			this.setFocus();
		}
	}

	/**
	 * @param {string | undefined } inputValue
	 * @returns {Promise<*[]>}
	 */
	async getRecipients(inputValue = undefined) {
		// get mailing list

		this.recipients.length = 0;

		const result = await APIV5.instance.objectList(
			{ classKid: 'K_NODE;MAILINGLIST' },
			{ id: 'mail-form-input.get-recipients' },
		);
		for (const [kid, m] of Object.entries(result.list)) {
			this.recipients.push({
				person: {
					kid,
					name: m.name,
					isa:  m.isa,
				},
			});
		}

		/** @type {any} */
		const data = {};
		if (inputValue) {
			data.query = new Query(queryRecipientsAutocomplete);
			data.variable = { value: inputValue };
			this.recipients = this.recipients.filter(
				r => r.person.name.toLocaleLowerCase().contains(inputValue.toLocaleLowerCase(), 0),
			);
		}
		else {
			data.query = new Query(queryRecipientsSuggestion);
		}
		const response = await APIV5.instance.queryExec(data, { id: 'mail-form-input.get-recipients' });
		const { rows } = response.result;

		if (rows && rows.length > 0) {
			for (const row of rows) {
				if (row[1][0].kid !== 'NONE') {
					/** @type {any} */
					const recipient = {
						email: {
							kid:  row[1][0].kid,
							name: row[1][0].name,
							isa:  row[1][0].isa,
						},
					};
					if (row[0][0].name && row[0][0].name !== '##no name##') {
						recipient.person = {
							kid:  row[0][0].kid,
							name: row[0][0].name,
							isa:  row[0][0].isa,
						};
					}
					this.recipients.push(recipient);
				}
			}
		}
		else if (Utils.checkEmail(inputValue)) {
			this.recipients.push({
				email: {
					name: inputValue,
					isa:  'K_NODE;EMAIL',
				},
			});
		}
		return this.recipients;
	}

	/**
	 * @param {any} recipient
	 * @returns {string}
	 */
	getRecipientName(recipient) {
		return recipient?.person?.name ?? recipient?.email?.name ?? '';
	}

	/**
	 * @param {KeyboardEvent} event
	 */
	keyup(event) {
		if (event.key === 'Enter') {
			event.preventDefault();
			this.addEmail();
		}
	}

	setFocus() {
		this.$element.find(`.form-control[name=recipient_${this.type}]`).val('').focus();
	}

	$onInit() {
		if (!Array.isArray(this.recipients)) {
			this.recipients = [];
		}
		if (!Array.isArray(this.data)) {
			this.data = [];
		}
	}
}
